// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"6c55a12f","339":"49c6fb74","579":"a873d1e8","629":"69d4a6d4","640":"0f3f06e1","842":"e3c3dbfe","981":"fe73eb34"}[chunkId] + ".chunk.js";
};